import { defineStore } from "pinia"

import http from "~/services/http"
import type { StickyNoteRequest } from "~/types/stickyBoard"

interface ISubmitParams extends IErrorAndSuccessCallbacks {
  request: StickyNoteRequest
  text: string
  color: string
}

export const useStudentStickyNotesStore = defineStore("studentStickyNotesStore", {
  state: () => ({
    requests: [] as StickyNoteRequest[],
    dismissedIds: [] as number[],
  }),

  getters: {
    activeRequest: (state) => state.requests.find((request) => !state.dismissedIds.includes(request.id)) ?? null,
  },

  actions: {
    fetchRequests() {
      http.get({
        url: "v2/sticky-notes/student/requests",
        successCallback: (ctx) => {
          this.requests = ctx.response._data.requests
        },
      })
    },

    receiveRequest(request: StickyNoteRequest) {
      if (!this.requests.some((existing) => existing.id === request.id)) {
        this.requests.push(request)
      }
    },

    removeRequest(id: number) {
      this.requests = this.requests.filter((request) => request.id !== id)
    },

    dismiss(id: number) {
      this.dismissedIds.push(id)
    },

    reopen() {
      this.dismissedIds = []
    },

    submit({ request, text, color, successCallback, errorCallback }: ISubmitParams) {
      http.post({
        url: `v2/sticky-notes/student/requests/${request.id}/notes`,
        body: { text, color },
        successCallback: (ctx) => {
          this.removeRequest(request.id)
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          if (ctx.status === 404) {
            this.removeRequest(request.id)
          }
          errorCallback && errorCallback(ctx)
        },
      })
    },
  },
})
